module.exports = __webpack_public_path__ + "img/icon_flagship.459f0899.svg";